import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface ExtendedIconProps extends IconWrapperProps {
  color?: string;
}

const EyeIcon = ({ color = 'currentColor', ...rest }: ExtendedIconProps) => (
  <IconWrapper width="24" height="24" title="Show password" {...rest}>
    <path
      d="M12 5C7 5 2.73 8.11 1 12.5 2.73 16.89 7 20 12 20s9.27-3.11 11-7.5C21.27 8.11 17 5 12 5zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
      fill={color}
    />
  </IconWrapper>
);

export default EyeIcon;
